module.exports = __webpack_public_path__ + "media/images/client/RentSearchApplication/trash-92bcb047026b8db328f0479dd409f316.svg";